import React from "react";
import { Navigate } from "react-router-dom";
import Layout from "../../../components/Layout";
import { PageContainer } from "../../../components/shared";
import SessionBootstrap from "../../../components/auth/SessionBootstrap";
import { isEnrolmentConfined, useAuthSession } from "../../../lib/http/session";
import { useSessionUser } from "../../../utils/auth/sessionUser";
import EnrolmentGate from "./EnrolmentGate";
import SecuritySettings from "./SecuritySettings";

// /settings/security — identity's enrol_url (contract §11). A confined session gets the standalone gate: it cannot load /me or the app shell.
const SecurityPage: React.FC = () => {
	const { status, info } = useAuthSession();
	const profile = useSessionUser();

	if (status === "anonymous") return <Navigate to="/login" replace />;
	if (status !== "authenticated" || !info) return <SessionBootstrap />;
	if (isEnrolmentConfined(info)) return <EnrolmentGate />;
	if (!profile) return <SessionBootstrap />;

	return (
		<Layout>
			<PageContainer title="Security" subtitle="Sign-in methods and account recovery" data-testid="security-page" maxWidth={960}>
				<SecuritySettings />
			</PageContainer>
		</Layout>
	);
};

export default SecurityPage;
